import { z } from 'zod';

export const CatalogItemStatusSchema = z.enum([
  'DRAFT',
  'ACTIVE',
  'INACTIVE',
  'SUSPENDED',
  'BLOCKED',
]);
export const CATALOG_ITEM_STATUSES = CatalogItemStatusSchema.options;

export type CatalogItemStatus = z.infer<typeof CatalogItemStatusSchema>;
